import { getDomainURL } from '../utils/sessionUtils'

const domain = getDomainURL()

const DIGITAL_URL = '/digital/moneymovement'

const routerpath = {
  pages: {
    home: '/',
    manual: '/manual',
    search: '/search',
    edit: '/edit',
    firsttime: '/firsttime',
    findbills: '/findbills',
    verifybills: '/verifybills',
    payeedashboard: '/payeedashboard',
    billdetails: '/billdetails',
    reviewdetails: '/reviewdetails',
    onetimepaymentedit: '/onetimepaymentedit',
    addedbillerPayment: '/addedbillerPayment',
    openbillpay: `${DIGITAL_URL}/openbillpay`
  }
}

export const FIRST_TIME_PAGE = 'firsttimesharedaccess'

export const EXTERNAL_ROUTES = {
  openbillpay: `${domain}${DIGITAL_URL}/openbillpay`,
  payeemanagement: `${domain}${DIGITAL_URL}/payeemanagement-billpay`
}
export default routerpath
